module.exports = __webpack_public_path__ + "static/media/DSC_1035.21b14fb8.jpg";